import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { BsSearch } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import * as _clientser from "../../_redux/_services/ClientsSlice";
import * as _props from "../../_redux/_services/JobPostingSlice";
import * as _ser from "../../_redux/_services/ApplicantsSlice";
import { customFieldsAsync } from "../../_redux/_services/UserManagerSlice";
import { defaultPostingsData } from "../../_utilities/defaultfieldsModel";
import getUserDetails, {
  GetUserInfo,
  GetUserId,
} from "../../_utilities/getUserInfo";
import CkEditor from "../../components/CkEditor/CkEditor";

const PostingsComponent = ({
  componentType,
  input,
  iniValue,
  actions,
  onValidData,
  disableSubmitBtn,
  isJobDetails,
  onResetValue,
}) => {
  const initalState = { data: null, message: "", isloader: true };
  const [getDetails, setGetDetails] = useState(iniValue);
  const [isjobDesc, setIsjobDesc] = useState(false);
  const [isjobDescForSM, setIsjobDescForSM] = useState(false);
  const [clientNameObj, setClientNameObj] = useState({});
  const [managerObj, setManagerObj] = useState([]);
  const [teamLeadObj, setteamLeadObj] = useState([]);
  const [recruiterObj, setRecruiterObj] = useState([]);
  const [selectedJobTypes, setSelectedJobTypes] = useState([]);
  const [disableBtn, setDisableBtn] = useState(disableSubmitBtn);
  const [clientList, setClientList] = useState([]);
  // const [GetUserId, setUserId] = useState(null);
  const [recruitersObj, setRecruitersObj] = useState([]);
  const [systemRole, setSystemRole] = useState(false);
  const [listSegments, setListSegments] = useState([]);
  const [jobSegment, setJobSegment] = useState(null);
  const [isSegmentValue, setIsSegmentValue] = useState(false);
  const [jobDescValue, setJobDescValue] = useState("");
  const [jobDescforSMValue, setJobDescforSMValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [locationsOptions, setLocationsOptions] = useState([]);
  const [locationValue, setLocationValue] = useState({
    id: 0,
    location: "",
    type: "",
  });

  const clientVal = useSelector((state) => state.FilterClients.data);
  const teamleadList = useSelector(
    (state) => state.GetManagerTeamlead.teamLeads,
  );
  const managerList = useSelector((state) => state.GetManagerTeamlead.manager);
  const recruiterList = useSelector(
    (state) => state.GetManagerTeamlead.recruiter,
  );
  const customFieldsData = useSelector((state) => state.CustomFields.data);
  const segmentList = useSelector((state) => state.GetListSegments.data);
  const parsedJobData = useSelector((state) => state.Jobparsing.data?.parsedJD);
  const endClientsData = useSelector((state) => state.GetEndClients.data);

  // defaultDropdownOptionValues
  const [workModelValues, setWorkModelValues] = useState([]);
  const [jobStatusValues, setJobStatusValues] = useState([]);
  const [jobTypeValues, setJobTypeValues] = useState([]);
  const [priorityValues, setPriorityValues] = useState([]);

  // customFields
  const [customFieldsArray, setCustomFieldsArray] = useState([]);
  const [getcustomFields, setGetCustomFields] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (getDetails?.clientId) {
      dispatch(_clientser.getEndClientsAsync(getDetails.clientId));
    }
  }, [getDetails?.clientId, dispatch]);

  const hasEndClient =
    !!getDetails?.clientId &&
    endClientsData?.endClients &&
    endClientsData.endClients.length > 0 &&
    endClientsData?.endClients?.filter((c) => c.status === 1).length > 0;

  useEffect(() => {
    defaultPostingsData.forEach((list) => {
      if (list.fieldName === "Work model") {
        setWorkModelValues(list.customValues);
      }
      if (list.fieldName === "JobStatus") {
        setJobStatusValues(list.customValues);
      }
      if (list.fieldName === "JobType") {
        setJobTypeValues(list.customValues);
      }
      if (list.fieldName === "priority") {
        setPriorityValues(list.customValues);
      }
    });
  }, []);

  useEffect(() => {
    async function init() {
      let userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
      dispatch(_props.getListSegmentsAsync());
      dispatch(_props.getManagerTeamleadAsync("team Lead", userId));
      dispatch(_props.getManagerTeamleadAsync("manager", userId));
      dispatch(_props.getManagerTeamleadAsync(" ", userId));
    }
    init();
  }, []);

  useEffect(() => {
    if (teamleadList && teamleadList.length > 0) {
      const data = JSON.parse(JSON.stringify(teamleadList));
      setteamLeadObj(data);
      // dispatch(_props.getManagerTeamleadStartReducer({}))
    }
  }, [teamleadList]);

  useEffect(() => {
    if (managerList && managerList.length > 0) {
      const data = JSON.parse(JSON.stringify(managerList));
      setManagerObj(data);
      // dispatch(_props.getManagerTeamleadStartReducer({}))
    }
  }, [managerList]);

  useEffect(() => {
    if (recruiterList && recruiterList.length > 0) {
      const data = JSON.parse(JSON.stringify(recruiterList));
      let newArray = [];
      data.forEach((list) => {
        let obj = {
          id: list.id.toString(),
          name: `${list.firstName} ${list.lastName}`,
          emailId: list.emailId,
        };
        newArray.push(obj);
      });
      setRecruiterObj(newArray);
      // dispatch(_props.getManagerTeamleadStartReducer({}))
    }
  }, [recruiterList]);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let customPostingFieldsData = data.filter(
        (x) => x.moduleId.toString() === "1" && x.fieldType === "custom",
      );
      if (customPostingFieldsData.length > 0) {
        let Array = {};
        customPostingFieldsData.forEach((item) => {
          item.customValues =
            item.dataType.toLowerCase() !== "text box"
              ? JSON.parse(item.customValues)
              : "";
          item.moduleId = item.moduleId.toString();
          Array[item.fieldName] =
            item.dataType.toLowerCase() !== "text box" ? [] : "";
        });
        setCustomFieldsArray(customPostingFieldsData);
        if (componentType === "Create") {
          setGetCustomFields(Array);
        }
      }
      let overrideDefaultPostingFieldsData = data.filter(
        (x) => x.moduleId.toString() === "1" && x.fieldType === "default",
      );
      if (overrideDefaultPostingFieldsData.length > 0) {
        overrideDefaultPostingFieldsData.forEach((list) => {
          if (list.fieldName === "Work model") {
            setWorkModelValues(JSON.parse(list.customValues));
          }
          if (list.fieldName === "Job status") {
            setJobStatusValues(JSON.parse(list.customValues));
          }
          if (list.fieldName === "Job type") {
            setJobTypeValues(JSON.parse(list.customValues));
          }
          if (list.fieldName === "Priority") {
            setPriorityValues(JSON.parse(list.customValues));
          }
        });
      }
      // dispatch(customFieldsStartReducer({}))
    }
  }, [customFieldsData]);

  useEffect(() => {
    if (segmentList?.length > 0) {
      const activeSegments = segmentList
        .filter((segment) => segment.segmentStatus === 1)
        .map(({ id, segmentName }) => ({ id, label: segmentName }));
      setListSegments(activeSegments);
    } else {
      setListSegments([]);
    }
  }, [segmentList]);

  useEffect(() => {
    let data = JSON.parse(JSON.stringify(getDetails));
    if (data && clientList.length > 0) {
      //componentType !== "Create"
      let clientValue = JSON.parse(JSON.stringify(clientList));
      let findClientIndex = clientValue?.findIndex(
        (x) => x.clientName === data.clientName,
      );
      if (findClientIndex !== -1) {
        data.clientName = clientValue[findClientIndex];
        data["clientId"] = clientValue[findClientIndex].id.toString();
        formik.values.clientId = clientValue[findClientIndex].id.toString();
        setClientNameObj(clientValue[findClientIndex]);
      }
    }
    if (data && recruiterObj.length > 0) {
      //componentType !== "Create" &&
      let filterObj = [];
      data?.recruiters?.forEach((id) => {
        let findIndex = recruiterObj?.findIndex((x) => x.id === id);
        if (findIndex !== -1) {
          filterObj.push(recruiterObj[findIndex]);
        }
      });
      setRecruitersObj(filterObj);
    }
  }, [clientList, recruiterObj, dispatch]);

  useEffect(() => {
    const init = async () => {
      if (clientVal && clientVal.length > 0) {
        let clientValue = JSON.parse(JSON.stringify(clientVal));
        let ClientData = [];
        clientValue.forEach((e) => {
          if (e.status === "Active") {
            e.clientName = e.clientName;
            ClientData.push(e);
          }
        });
        setClientList(ClientData);
      } else {
        const userInfo = await getUserDetails();
        if (userInfo) {
          dispatch(_clientser.filterClientsAsync(""));
        }
      }
    };
    init();
  }, [clientVal]);

  useEffect(() => {
    if (componentType === "Create") {
      formik.values.jobStatus = "Active";
    }
  }, []);

  useEffect(() => {
    if (input) {
      const data = JSON.parse(JSON.stringify(input));
      // For non-"Create", check jobCode; for "Create" proceed
      if (data && (componentType !== "Create" ? data.jobCode !== "" : true)) {
        const stringJobType = data.jobType.toString();
        const listofjobType = stringJobType
          ? stringJobType.split(",").map((t) => t.trim().replace(/-/g, " "))
          : [];
        let array = [];
        jobTypeValues.forEach((item) => {
          listofjobType.forEach((jobType) => {
            if (item?.toLowerCase().trim() === jobType?.toLowerCase().trim()) {
              array.push(item);
            }
          });
        });
        setSelectedJobTypes(array);
        formik.values.jobTitle = data.jobTitle;
        formik.values.externalSystemID = data.externalSystemID;
        formik.values.workModel =
          workModelValues.find(
            (v) => v.toLowerCase() === (data.workModel || "").toLowerCase(),
          ) || data.workModel;
        formik.values.jobStatus =
          componentType === "Create"
            ? data.jobStatus || "Active"
            : data.jobStatus;
        formik.values.jobType = data.jobType.toString();
        formik.values.clientId = data.clientId;
        formik.values.clientBillRate = data.clientBillRate;
        formik.values.payBillRate = data.payBillRate;
        formik.values.location = data.location || '';
        formik.values.locationDetails = data.locationDetails || '';
        setLocationValue({
          id: 0,
          location: data.location || "",
          type: "",
        });
        formik.values.manager = data.manager;
        formik.values.teamLead = data.teamLead;
        formik.values.primarySkills = data.primarySkills;
        formik.values.segmentId = data.segmentId;
        formik.values.isClientConfidential = data.isClientConfidential;
        formik.values.endClientId = data.endClientId;
        formik.values.isEndClientConfidential = data.isEndClientConfidential;

        setIsSegmentValue(
          componentType === "Create"
            ? false
            : (componentType === "Edit" && data.segmentId) ||
                componentType === "view",
        );

        // Parse and set custom fields
        const customFieldsData = JSON.parse(data.customFields || "[]");
        if (customFieldsData.length > 0) {
          const formatCustomFields = {};
          customFieldsData.forEach(({ key, value }) => {
            formatCustomFields[key] = value;
          });
          setGetCustomFields(formatCustomFields);
        }

        if (segmentList?.length) {
          const jobSegment = segmentList.find((s) => s.id === data.segmentId);
          if (jobSegment) setJobSegment(jobSegment.segmentName);
        } else {
           data.segmentId = null;
        }
        setGetDetails(data);
        setJobDescValue(data.jobDesc);
        setJobDescforSMValue(data.jobDescForSM);

      }
    }
  }, [input, componentType, segmentList, jobTypeValues]);

  const onChangeHandler = (data, type) => {
    if (type === "jobDesc" || type === "jobDescForSM") {
      if (type === "jobDesc") {
        setJobDescValue(data);
        setIsjobDesc(data === " " ? true : false);
      } else if (type === "jobDescForSM") {
        setJobDescforSMValue(data);
        setIsjobDescForSM(data === " " ? true : false);
      }
      formik.setFieldValue(type, data);
    } else {
      let obj = JSON.parse(JSON.stringify(getDetails));
      if (type === "clientName") {
        obj["clientName"] = data;
      } else if (type === "clientId") {
        obj["endClientId"] = null;
        obj["isEndClientConfidential"] = 0;
        let filterData = clientList.filter(
          (x) => parseInt(x.id) === parseInt(data),
        );
        if (filterData.length > 0) {
          obj["clientName"] = filterData[0];
          obj["clientId"] = filterData[0].id;
          setClientNameObj(filterData[0]);
        } else {
          obj["clientName"] = {};
          setClientNameObj({});
        }
        obj["clientId"] = data !== undefined ? data : "";
        formik.setFieldValue("clientId", data !== undefined ? data : "");
      } else if (type === "jobType") {
        obj[type] = data.toString();
        formik.setFieldValue(type, data.toString());
        setSelectedJobTypes(data);
      } else if (type === "recruiters") {
        let array = [];
        data.forEach((selected) => {
          let data = recruiterObj.filter((x) => x.id === selected);
          if (data.length > 0) {
            array.push(data[0]);
          }
        });
        setRecruitersObj(array);
        obj[type] = data;
      }
      if (type !== "jobType" && type !== "ClientID" && type !== "recruiters") {
        obj[type] = data;
        formik.setFieldValue(type, data);
      }
      setGetDetails(obj);
    }
  };

  const onChangeCustomFieldsHandler = (value, type) => {
    setGetCustomFields((prevousValue) => ({ ...prevousValue, [type]: value }));
    formik.validateForm();
  };

  const getValidationSchema = (listSegments = []) => {
    const shape = {
      jobTitle: Yup.string()
        .min(3, "Must be at least 3 characters") // fixed message
        .max(100, "Must be less than 100")
        .required("Please enter a job title"),
      externalSystemID: Yup.string()
        .nullable()
        .max(40, "Must be less than 40 characters"),
      workModel: Yup.string().required("Please select a work model"),
      jobStatus: Yup.string(),
      jobType: Yup.string().required("Please select a job type"),
      clientBillRate: Yup.string(),
      payBillRate: Yup.string()
        .matches(
          /^[0-9]+[a-z]|[a-z]+[0-9]|[0-9]/,
          "Please provide a valid pay rate or salary",
        )
        .required("Please provide a valid pay rate or salary"),
      location: Yup.string().required("Please enter a location"),
      jobDesc: Yup.string().required(
        "Job description is required. Please provide a description",
      ),
    };
    if (listSegments.length !== 0) {
      shape.segmentId = Yup.string().test(
        "required-when-segments-exist",
        "Please select a segment",
        function (value) {
          const { path, createError } = this;
          if (!value || value === "0") {
            return createError({ path, message: "Please select a segment" });
          }
          return true;
        },
      );
    }
    return Yup.object(shape);
  };

  // Build errors for mandatory custom fields
  const validateMandatoryCustomFields = (fieldsArray = [], valuesObj = {}) => {
    valuesObj = valuesObj || {};
    const cfErrors = {};
    fieldsArray.forEach((f) => {
      if (Number(f.mandatory) !== 1) return; // only required
      const key = f.fieldName;
      const dt = (f.dataType || "").toLowerCase().trim();
      const v = valuesObj[key];

      if (dt === "text box") {
        if (v == null || String(v).trim() === "") cfErrors[key] = "Required";
      } else if (dt === "single select") {
        if (v == null || String(v).trim() === "") cfErrors[key] = "Required";
      } else if (dt === "multi select") {
        if (!Array.isArray(v) || v.length === 0)
          cfErrors[key] = "Select at least one option";
      }
    });
    return cfErrors;
  };

  const formik = useFormik({
    initialValues: iniValue,
    validationSchema: getValidationSchema(listSegments),
    validateOnChange: true,
    validateOnBlur: true,
    validate: (values) => {
      const errors = {};
      // onCkeditorValidate();
      if (isJobDetails === true) {
        onResetValue(true);
      }
      // uses latest customFieldsArray + getcustomFields from this render
      const cfErrors = validateMandatoryCustomFields(
        customFieldsArray,
        getcustomFields,
      );
      if (Object.keys(cfErrors).length) {
        errors.customFields = cfErrors;
      }
      return errors;
    },

    onSubmit: async (values) => {
      const cfErrors = validateMandatoryCustomFields(
        customFieldsArray,
        getcustomFields,
      );
      if (Object.keys(cfErrors).length > 0) {
        formik.setErrors((prev) => ({
          ...(prev || {}),
          customFields: cfErrors,
        }));
        formik.setTouched(
          (prev) => ({
            ...(prev || {}),
            customFields: Object.fromEntries(
              Object.keys(cfErrors).map((k) => [k, true]),
            ),
          }),
          true,
        );
        return;
      }

      let ArrayOfCustomFields = [];
      if (getcustomFields !== null) {
        let keys = Object.keys(getcustomFields);
        keys.forEach((items, i) => {
          let obj = { key: items, value: getcustomFields[items] };
          ArrayOfCustomFields.push(obj);
        });
      }
      setDisableBtn(true);
      if (!isjobDesc && !isjobDescForSM) {
        values.clientName = getDetails.clientName
          ? getDetails.clientName
          : clientNameObj;
        values.customerId = getDetails.customerId;
        values.jobCode = getDetails.jobCode;
        values.externalSystemID = getDetails.externalSystemID;
        values.jobDesc = getDetails.jobDesc;
        values.jobDescForSM = getDetails.jobDescForSM;
        values.priority = getDetails.priority;
        values.segmentId = getDetails.segmentId;
        values.secondarySkills = getDetails.secondarySkills;
        values.userFirstName = getDetails.userFirstName;
        values.userId = getDetails.userId;
        values.userLastName = getDetails.userLastName;
        values["customFields"] = JSON.stringify(ArrayOfCustomFields);
        values["recruiters"] = JSON.stringify(getDetails.recruiters);
        values["jobDesc"] = jobDescValue;
        values["jobDescForSM"] = jobDescforSMValue;
        values["listofRecruitersemails"] = [];
        values["isClientConfidential"] = getDetails.isClientConfidential
          ? 1
          : 0;
        values["endClientId"] =
          hasEndClient && getDetails.endClientId ? getDetails.endClientId : null;
        values["isEndClientConfidential"] =
          hasEndClient && getDetails.isEndClientConfidential ? 1 : 0;
        values["locationDetails"] = getDetails.locationDetails;
        recruitersObj.forEach((item, index) => {
          let key = `recruitersemails[${index}]`;
          let obj = { [key]: { name: item.name, emailid: item.emailId } };
          values["listofRecruitersemails"].push(obj);
        });
        await onValidData(values);
      }
    },
  });

  // Auto-scroll to first error field on submit attempt
  useEffect(() => {
    if (formik.submitCount > 0 && !formik.isValid) {
      const getFirstErrorKey = (obj, prefix = "") => {
        for (const key in obj) {
          const path = prefix ? `${prefix}.${key}` : key;
          if (
            typeof obj[key] === "object" &&
            obj[key] !== null &&
            !Array.isArray(obj[key])
          ) {
            return getFirstErrorKey(obj[key], path);
          }
          return path;
        }
      };

      const firstErrorKey = getFirstErrorKey(formik.errors);
      if (firstErrorKey) {
        const element =
          document.getElementsByName(firstErrorKey)[0] ||
          document.getElementById(firstErrorKey);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          // Optional: element.focus();
        }
      }
    }
  }, [formik.submitCount]);

  useEffect(() => {
    if (isJobDetails === true) {
      formik.handleSubmit();
    }
  }, [isJobDetails]);

  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    async function init() {
      const userIdData = await GetUserInfo();
      setUserInfo(userIdData);
    }
    init();
  }, []);

  useEffect(() => {
    if (userInfo) {
      let bool =
        userInfo[0].systemroles === "Manager" ||
        userInfo[0].systemroles === "Admin"
          ? true
          : false;
      setSystemRole(bool);
    }
  }, [userInfo]);

  // const handleFileChange = (event) => {
  //   const uploadedFile = event.target.files[0];
  //   if (uploadedFile) {
  //     setFile(uploadedFile);
  //   dispatch(updateLoader(true));
  //   let formData = new FormData();
  //   formData.append("JD", uploadedFile);
  //   dispatch(_props.jobparsingAsync(formData, true));
  //   }

  // };

  // const handleFileChange = async (event) => {
  //   const uploadedFile = event.target.files[0];
  //   if (!uploadedFile) return;

  //   try {
  //     setError("");
  //     setFile(uploadedFile); // ✅ store the file in state
  //     const content = await extractFileContent(uploadedFile); // ✅ use uploadedFile, not file
  //     setText(content);
  //   } catch (err) {
  //     console.error(err);
  //     setError(err.message || "Failed to read file.");
  //   }
  // };

  // 🔹 Heading-based parser

  //  // 🔹 Keyword-based parser
  //   const parseJDByKeywords = (text) => {
  //   const clean = text.replace(/\s+/g, " ").trim();

  //   const jobTitleMatch = clean.match(/(We are looking for|Position|Role|Job Title)[:\s-]*([A-Z][a-zA-Z\s]+)/i);
  //   const locationMatch = clean.match(/(Location|Based in|at)[:\s-]*([A-Za-z,\s]+)/i);
  //   const experienceMatch = clean.match(/(\d+\+?\s*(years|yrs))/i);

  //   // Dictionary of common skills
  //   const skillsList = ["Android", "Kotlin", "Java", "C\\+\\+", "React", "Node", "AWS", "SQL", "Linux"];
  //   const skillsRegex = new RegExp(`\\b(${skillsList.join("|")})\\b`, "gi");
  //   const skills = clean.match(skillsRegex) || [];

  //   // Responsibilities (verb-starting sentences)
  //   const respMatches = clean.match(/(?:Lead|Design|Develop|Implement|Build|Maintain)[^.]+[.]/gi);

  //   return {
  //     "Job Title": jobTitleMatch ? jobTitleMatch[2].trim() : "",
  //     "Experience": experienceMatch ? experienceMatch[1] : "",
  //     "Location": locationMatch ? locationMatch[2].trim() : "",
  //     "Responsibilities": respMatches ? respMatches.join(" ") : "",
  //     "Skills": [...new Set(skills)].join(", ")
  //   };
  // };

  // 🔹 Keyword-based parser (fallback)
  // const parseJDByKeywords = (text) => {
  //   const clean = text.replace(/\s+/g, " ").trim();

  //   const jobTitleMatch = clean.match(/(We are looking for|Position|Role|TITLE|Job Title)[:\s-]*([A-Z][a-zA-Z\s]+)/i);
  //   const locationMatch = clean.match(/(Location|Based in|at)[:\s-]*([A-Za-z,\s]+)/i);
  //   const experienceMatch = clean.match(/(\d+\+?\s*(years|yrs))/i);

  //   const skillsList = ["Android", "Kotlin", "Java", "C\\+\\+", "React", "Node", "AWS", "SQL", "Linux"];
  //   const skillsRegex = new RegExp(`\\b(${skillsList.join("|")})\\b`, "gi");
  //   const skills = clean.match(skillsRegex) || [];

  //   const respMatches = clean.match(/(?:Lead|Design|Develop|Implement|Build|Maintain)[^.]+[.]/gi);

  //   return {
  //     "Job Title": jobTitleMatch ? jobTitleMatch[2].trim() : "",
  //     "Experience": experienceMatch ? experienceMatch[1] : "",
  //     "Location": locationMatch ? locationMatch[2].trim() : "",
  //     "Responsibilities": respMatches ? respMatches.join(" ") : "",
  //     "Keyskills": [...new Set(skills)]
  //   };
  // };

  /**
   * Parse JD with dynamic skill extraction only
   */

  // useEffect(() => {
  //     if (parsedJobData) {
  //       const modifyedJobData = { ...parsedJobData };
  //       // modifyedJobData.jobType = getPersistValue(modifyedJobData?.jobType , jobTypeValues, setJobTypeValues);
  //       // modifyedJobData.workModel = getPersistValue(modifyedJobData?.workModel, workModelValues, setWorkModelValues);
  //       // formik.values.workModel = getPersistValue(modifyedJobData?.workModel, workModelValues, setWorkModelValues);
  //       // modifyedJobData.jobStatus = "";
  //       // modifyedJobData.jobDescValue = modifyedJobData?.JobDesc;
  //       // modifyedJobData.primarySkills = modifyedJobData?.primarySkills?.length > 0 ? modifyedJobData?.primarySkills.join(", ") :"";
  //       // modifyedJobData.recruiters = [];
  //       // modifyedJobData["parsedJD"] = parsedJobData ? 1 : 0;
  //       dispatch(updateLoader(false));
  //       console.log("modifyedJobData!!!!!!!!", modifyedJobData);
  //       setGetDetails(modifyedJobData);
  //     setJobDescValue(modifyedJobData.jobDesc);

  //       //  formik.values.jobTitle = modifyedJobData.jobTitle;
  //       //  formik.values.jobStatus = modifyedJobData.jobStatus;
  //       dispatch(_props.jobparsingStartReducer(initalState))
  //     }
  // }, [parsedJobData])

  // useEffect(() => {
  //     if (parsedJobData) {
  //       const modifyedJobData = { ...parsedJobData };
  //       //  setGetDetails({
  //     modifyedJobData["jobTitle"] = parsedJobData["Job Title"] || "";
  //     modifyedJobData["JobDesc"] = parsedJobData["Job Description"] || "";
  //     modifyedJobData["jobResponsibilities"] = parsedJobData["Job Responsibilities"] || parsedJobData["Responsibilities"] || "";
  //     modifyedJobData["location"] = parsedJobData["Location"] || "";
  //     modifyedJobData["primarySkills"] = parsedJobData["Keyskills"] || [];  // ✅ now array
  //    modifyedJobData["experience"] = parsedJobData["Experience"] || "";
  //   // });
  //       modifyedJobData.jobType = getPersistValue(modifyedJobData?.jobType , jobTypeValues, setJobTypeValues);
  //       modifyedJobData.workModel = getPersistValue(modifyedJobData?.workModel, workModelValues, setWorkModelValues);
  //       formik.values.workModel = getPersistValue(modifyedJobData?.workModel, workModelValues, setWorkModelValues);
  //       modifyedJobData.jobStatus = "";
  //       modifyedJobData.jobDescValue = modifyedJobData?.JobDesc;
  //       modifyedJobData.primarySkills = modifyedJobData?.primarySkills?.length > 0 ? modifyedJobData?.primarySkills.join(", ") :"";
  //       modifyedJobData.recruiters = [];
  //       modifyedJobData["parsedJD"] = parsedJobData ? 1 : 0;
  //       dispatch(updateLoader(false));
  //       console.log("modifyedJobData!!!!!!!!", modifyedJobData);
  //       setGetDetails(modifyedJobData);
  //     setJobDescValue(modifyedJobData.jobDesc);

  //       //  formik.values.jobTitle = modifyedJobData.jobTitle;
  //       //  formik.values.jobStatus = modifyedJobData.jobStatus;
  //       dispatch(_props.jobparsingStartReducer(initalState))
  //     }
  // }, [parsedJobData])

  // useEffect(() => {
  // if(text){
  //   console.log("text_______________________", text);
  // }
  // }, [text])

  const getPersistValue = (value, obj, setObj) => {
    if (value) {
      let Index = obj.findIndex(
        (item) => item.toLowerCase() === value.toLowerCase(),
      );
      if (Index !== -1) {
        return obj[Index];
      } else {
        setObj([...obj, value]);
        return value;
      }
    }
  };

  // Initialize locations
  const countriesData = useSelector((state) => state.CountriesListByValue.data);
  useEffect(() => {
    if (countriesData && countriesData.length > 0) {
      setLoading(false);
      setLocationsOptions(countriesData);
      dispatch(_ser.getCountriesListByValueStartReducer(initalState));
    } else if (countriesData && countriesData.length === 0) {
      setLocationsOptions([]);
      setLoading(false);
    }
  }, [countriesData]);

  const renderClientColumn = () => {
    return (
      <div>
        <div className="client-section">
          <InputLabel shrink={false} className="custom-label">Client</InputLabel>
          <Autocomplete
            options={clientList || []}
            autoHighlight
            className="clientsearch1"
            sx={{
              width: 503,
              "& .MuiAutocomplete-clearIndicator": { display: "none" },
            }}
            style={{
              width: "100%",
              borderRadius: "120px",
            }}
            disableClearable={false}
            value={
              clientList?.find(
                (x) => String(x.id) === String(getDetails.clientId),
              ) || null
            }
            disabled={componentType === "view"}
            getOptionLabel={(option) => option?.clientName || ""}
            onChange={(e, value) => {
              onChangeHandler(
                value?.id ? String(value.id) : "",
                "clientId",
                getDetails,
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                className="boldlabel"
                onBlur={formik.handleBlur}
                error={Boolean(
                  formik.errors.clientId && formik.touched.clientId,
                )}
                helperText={
                  formik.errors.clientId && formik.touched.clientId
                    ? formik.errors.clientId
                    : ""
                }
              />
            )}
          />
          <BsSearch style={{ paddingTop: "1.2rem", marginLeft: "-2rem" }} />
        </div>

        <span style={{ float: "initial" }}>
          <FormControlLabel
            style={{
              backgroundColor:
                componentType === "view" ? "transparent" : "inherit",
            }}
            control={
              <Checkbox
                checked={Boolean(getDetails.isClientConfidential) || false}
                disabled={componentType === "view"}
                onChange={(e) =>
                  onChangeHandler(
                    e.target.checked,
                    "isClientConfidential",
                    getDetails,
                  )
                }
                name="isClientConfidential"
                sx={{
                  color: "#fbc02d",
                  borderRadius: "4px",
                  "&.Mui-checked": {
                    color: "#fbc02d",
                  },
                  "&:not(.Mui-checked)": {
                    color: "#000000",
                  },
                }}
              />
            }
            label={
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                Keep Client Confidential
              </span>
            }
          />
        </span>
      </div>
    );
  };

  return (
    <React.Fragment>
      {componentType !== "Create" ? (
        <div className="actionBtnRtl">
          {actions &&
            actions.map((item) => {
              if (item.type === "back") {
                return (
                  <Button
                    variant={item.variant}
                    className={item.class}
                    style={item.style}
                    size="small"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(item.navigateTo);
                    }}
                  >
                    {componentType !== "view" ? (
                      <Link
                        href="#"
                        style={{ color: "red", fontSize: "14px" }}
                        underline="always"
                      >
                        {" "}
                        {item.label}{" "}
                      </Link>
                    ) : (
                      <>{item.label} </>
                    )}
                  </Button>
                );
              } else if (item.type === "submit") {
                return (
                  <Button
                    variant={item.variant}
                    className={item.class}
                    disabled={disableBtn}
                    style={item.style}
                    size="small"
                    onClick={formik.handleSubmit}
                  >
                    {item.label}{" "}
                  </Button>
                );
              }
            })}
        </div>
      ) : (
        ""
      )}
      <div
        style={{ width: "100%", background: 'transparent' }}
        className={componentType === "view" ? "viewSection" : ""}
      >
        <div className="jobpostings-container">
          <h3 className="heading">Job Details</h3>
          <div
            style={{
              display: "flex",
              flexFlow: "wrap",
              marginTop: "30px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "23%" }}>
              <FormControl fullWidth>
                <InputLabel shrink={false} className="custom-label">Job Title *</InputLabel>
                <TextField
                  className="boldlabel"
                  error={
                    formik.errors.jobTitle && formik.touched.jobTitle ? true : false
                  }
                  helperText={
                    formik.errors.jobTitle && formik.touched.jobTitle
                      ? formik.errors.jobTitle
                      : ""
                  }
                  id="jobTitle"
                  variant="outlined"
                  autoComplete="off"
                  name="jobTitle"
                  value={getDetails?.jobTitle}
                  disabled={componentType === "view" ? true : false}
                  onChange={(e) =>
                    onChangeHandler(e.target.value, "jobTitle", getDetails)
                  }
                  onBlur={formik.handleBlur}
                />
              </FormControl>
            </div>
            <div style={{ width: "23%" }}>
              <FormControl fullWidth>
                <InputLabel shrink={false} className="custom-label">External Job ID</InputLabel>
                <TextField
                  className="boldlabel"
                  error={
                    formik.errors.externalSystemID &&
                    formik.touched.externalSystemID
                      ? true
                      : false
                  }
                  helperText={
                    formik.errors.externalSystemID &&
                    formik.touched.externalSystemID
                      ? formik.errors.externalSystemID
                      : ""
                  }
                  id="externalSystemID"
                  variant="outlined"
                  autoComplete="off"
                  name="externalSystemID"
                  value={getDetails.externalSystemID}
                  disabled={componentType === "view" ? true : false}
                  onChange={(e) =>
                    onChangeHandler(e.target.value, "externalSystemID", getDetails)
                  }
                  onBlur={formik.handleBlur}
                />
              </FormControl>
            </div>
            <div style={{ width: "23%" }}>
              <FormControl
                fullWidth
                autoComplete="off"
                error={
                  formik.errors.jobStatus && formik.touched.jobStatus
                    ? true
                    : false
                }
                sx={{
                  "& .MuiInputLabel-root": {
                    color: "#000",
                  },
                }}
              >
                <InputLabel shrink={false} className="custom-label">Job Status *</InputLabel>
                <Select
                  id="jobStatus"
                  value={
                    componentType === "Create" && getDetails.jobStatus === ""
                      ? "Active"
                      : getDetails.jobStatus
                  }
                  name="jobStatus"
                  disabled={componentType === "view" ? true : false}
                  autoComplete="off"
                  onChange={(e) =>
                    onChangeHandler(e.target.value, "jobStatus", getDetails)
                  }
                  onBlur={formik.handleBlur}
                  style={{ width: "100%", height: "3.5rem", borderRadius: "4px" }}
                >
                  {jobStatusValues?.map((name) => (
                    <MenuItem className="selectOptions" key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {formik.errors.jobStatus && formik.touched.jobStatus
                    ? formik.errors.jobStatus
                    : ""}
                </FormHelperText>
              </FormControl>
            </div>
            <div
              style={{
                width: "23%",
              }}
            >
              <FormControl fullWidth
                error={
                  formik.errors.jobType && formik.touched.jobType ? true : false
                }
                sx={{
                  "& .MuiInputLabel-root": {
                    color: "#000",
                  },
                }}
              >
                <InputLabel shrink={false} className="custom-label">Job Type *</InputLabel>
                <Select
                  id="jobType"
                  multiple
                  name="jobType"
                  disabled={componentType === "view" ? true : false}
                  value={selectedJobTypes}
                  onChange={(e) =>
                    onChangeHandler(e.target.value, "jobType", getDetails)
                  }
                  onBlur={formik.handleBlur}
                  renderValue={(selected) => {
                    if (typeof selected === "string") {
                      selected = selected.split(",");
                    }
                    const visibleValues = selected.slice(0, 2);
                    const remainingCount = selected.length - 2;
                    return (
                      <Box
                        sx={{
                          display: "flex",
                          gap: 0.5,
                          alignItems: "center",
                          flexWrap: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {visibleValues.map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                        {remainingCount > 0 && (
                          <span>{`+${remainingCount}`}</span>
                        )}
                      </Box>
                    );
                  }}
                >
                  {jobTypeValues?.map((name) => (
                    <MenuItem className="selectOptions" key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {formik.errors.jobType && formik.touched.jobType
                    ? formik.errors.jobType
                    : ""}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexFlow: "wrap",
              marginTop: "30px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "23%" }}>
              <FormControl
                fullWidth
                autoComplete="off"
                error={
                  formik.errors.workModel && formik.touched.workModel
                    ? true
                    : false
                }
                sx={{
                  "& .MuiInputLabel-root": {
                    color: "#000",
                  },
                }}
              >
                <InputLabel className="custom-label" shrink={false}>Work Model *</InputLabel>
                <Select
                  id="workModel"
                  value={getDetails.workModel}
                  name="workModel"
                  disabled={componentType === "view" ? true : false}
                  autoComplete="off"
                  onChange={(e) =>
                    onChangeHandler(e.target.value, "workModel", getDetails)
                  }
                  onBlur={formik.handleBlur}
                  style={{
                    width: "100%",
                    height: "3.5rem",
                    borderRadius: "4px",
                  }}
                >
                  {workModelValues?.map((name) => (
                    <MenuItem className="selectOptions" key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {formik.errors.workModel && formik.touched.workModel
                    ? formik.errors.workModel
                    : ""}
                </FormHelperText>
              </FormControl>
            </div>
            <div style={{ width: "23%" }}>
              <FormControl fullWidth
                sx={{
                  "& .MuiInputLabel-root": {
                    color: "#000",
                  },
                }}
              >
                <InputLabel className="custom-label" shrink={false}>Priority</InputLabel>
                <Select
                  style={{ width: "100%", height: "3.5rem", borderRadius: "4px" }}
                  value={getDetails.priority}
                  id="priority"
                  name="priority"
                  autoComplete="off"
                  disabled={componentType === "view" ? true : false}
                  onChange={(e) =>
                    onChangeHandler(e.target.value, "priority", getDetails)
                  }
                  onBlur={formik.handleBlur}
                >
                  {priorityValues?.map((name) => (
                    <MenuItem className="selectOptions" key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {listSegments.length > 0 ? (
              <div style={{ width: "23%" }}>
                <FormControl fullWidth
                  autoComplete="off"
                  error={Boolean(formik.touched.segmentId && formik.errors.segmentId)}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#000",
                    },
                  }}
                >
                  <InputLabel className="custom-label" shrink={false}>Select Segment *</InputLabel>
                  <Autocomplete
                    key={listSegments.length}
                    id="segment"
                    disabled={componentType === "view"}
                    options={listSegments}
                    autoHighlight
                    disableClearable={false}
                    freeSolo={false}
                    forcePopupIcon
                    isOptionEqualToValue={(option, value) =>
                      option?.id === value?.id
                    }
                    // getOptionKey={(option) => option.id}
                    getOptionLabel={(option) => option?.label || ""}
                    filterOptions={(options, { inputValue }) => {
                      const term = inputValue.trim().toLowerCase();
                      if (!term) return options;
                      return options.filter((o) =>
                        o.label.toLowerCase().includes(term),
                      );
                    }}
                    value={listSegments.find((x) => x.id === getDetails.segmentId) || null}
                    onChange={(e, value) => {
                      onChangeHandler(value?.id || "", "segmentId", getDetails);
                      formik.setFieldTouched("segmentId", true);
                      formik.setFieldValue("segmentId", value?.id || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="segmentId"
                        name="segmentId"
                        onBlur={formik.handleBlur}
                        error={
                          Boolean(formik.touched.segmentId && formik.errors.segmentId)
                        }
                        sx={{
                          "& .MuiInputLabel-root": {
                            color: "#000",
                          },
                        }}
                      />
                    )}
                  />
                  <FormHelperText>
                    {formik.touched.segmentId && formik.errors.segmentId}
                  </FormHelperText>
                </FormControl>
              </div>
            ) : (
              ""
            )}

            <div style={{ width: "23%" }}>
              <FormControl fullWidth>
                <InputLabel shrink={false} className="custom-label">Location *</InputLabel>
                <Autocomplete
                  freeSolo
                  loading={loading}
                  options={locationsOptions || []}
                  value={locationValue}
                  autoComplete
                  autoHighlight
                  selectOnFocus
                  handleHomeEndKeys
                  clearOnEscape
                  blurOnSelect={false}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "56px",
                    },
                  }}
                  getOptionLabel={(option) =>
                    typeof option === "string"
                      ? option
                      : option.location || ""
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.location === value.location
                  }
                  onInputChange={(event, value, reason) => {
                    if (reason === "input") {
                      const updatedValue = {
                        id: 0,
                        location: value ? value.trimStart() : "",
                        type: "",
                      };

                      setLocationValue(updatedValue);

                      formik.setFieldValue("location", updatedValue.location);

                      if (value.length > 2) {
                        setLoading(true);

                        const delayDebounceFn = setTimeout(() => {
                          dispatch(
                            _ser.getCountriesListByValueAsync(
                              value.toLowerCase(), "JP"
                            )
                          );
                        }, 300);

                        return () => clearTimeout(delayDebounceFn);
                      }
                    }
                  }}
                  onChange={(event, value) => {
                    const updatedValue = value
                      ? typeof value === "string"
                        ? {
                            id: 0,
                            location: value,
                            type: "",
                          }
                        : value
                      : {
                          id: 0,
                          location: "",
                          type: "",
                        };
                    setLocationValue(updatedValue);
                    formik.setFieldValue(
                      "location",
                      updatedValue.location
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      className="boldlabel"
                      autoComplete="new-password"
                      error={
                        formik.errors.location &&
                        formik.touched.location
                          ? true
                          : false
                      }
                      helperText={
                        formik.errors.location &&
                        formik.touched.location
                          ? formik.errors.location
                          : ""
                      }
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loading ? (
                              <CircularProgress size={20} />
                            ) : null}

                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </FormControl>
            </div>

            <div style={{ width: "23%", marginTop: listSegments.length > 0 ? "30px" : "0px" }}>
              <FormControl fullWidth>
                <InputLabel shrink={false} className="custom-label">Location Details</InputLabel>	
                <TextField
                  className="boldlabel"
                  autoComplete="off"
                  id="locationDetails"
                  variant="outlined"
                  name="locationDetails"
                  value={getDetails.locationDetails}
                  onChange={(e) =>
                    onChangeHandler(e.target.value, "locationDetails", getDetails)
                  }
                  onBlur={formik.handleBlur}
                  multiline={true}
                  rows={5}
                  disabled={componentType === "view" ? true : false}
                />
              </FormControl>
            </div>

          </div>
        </div>
        <div style={{ display: "flex", gap: "20px" }}>
          {/* Pay Section */}
          <div style={{width: "32.5%"}}>
            <div className="jobpostings-container">
              <h3 className="heading">Pay</h3>
              <FormControl fullWidth style={{ margin: "20px 0" }}>
                <InputLabel shrink={false} className="custom-label">Client Bill Rate</InputLabel>
                <TextField
                className="boldlabel"
                autoComplete="off"
                error={
                  formik.errors.clientBillRate && formik.touched.clientBillRate
                    ? true
                    : false
                }
                helperText={
                  formik.errors.clientBillRate && formik.touched.clientBillRate
                    ? formik.errors.clientBillRate
                    : ""
                }
                id="clientBillRate"
                variant="outlined"
                name="clientBillRate"
                value={getDetails.clientBillRate}
                onChange={(e) =>
                  onChangeHandler(e.target.value, "clientBillRate", getDetails)
                }
                onBlur={formik.handleBlur}
                multiline={true}
                rows={3.5}
                disabled={componentType === "view" ? true : false}
              />
            </FormControl>
            <FormControl fullWidth>
              <InputLabel shrink={false} className="custom-label">Pay rate / Salary *</InputLabel>
              <TextField
                className="boldlabel"
                autoComplete="off"
                error={
                  formik.errors.payBillRate && formik.touched.payBillRate
                    ? true
                    : false
                }
                helperText={
                  formik.errors.payBillRate && formik.touched.payBillRate
                    ? formik.errors.payBillRate
                    : ""
                }
                id="payBillRate"
                variant="outlined"
                name="payBillRate"
                value={getDetails.payBillRate}
                onChange={(e) =>
                  onChangeHandler(e.target.value, "payBillRate", getDetails)
                }
                onBlur={formik.handleBlur}
                multiline={true}
                rows={3.4}
                disabled={componentType === "view" ? true : false}
              />
              </FormControl>
            </div>
          </div>
          {/* Hiring Team Section */}
          <div style={{width: "32.5%"}}>
            <div className="jobpostings-container">
              <h3 className="heading">Hiring Team</h3>
                <FormControl style={{ margin: "20px 0" }}
                  fullWidth
                  error={
                    formik.errors.manager && formik.touched.manager ? true : false
                  }
                >
                  <InputLabel className="custom-label" shrink={false}>Manager</InputLabel>
                  <Autocomplete
                    disabled={componentType === "view" ? true : false}
                    options={managerObj}
                    getOptionLabel={(option) => {
                      let fullName = option.firstName + " " + option.lastName;
                      return fullName ? fullName : "";
                    }}
                    value={
                      getDetails.manager
                        ? managerObj.find((x) => x.id === getDetails.manager) ||
                          null
                        : null
                    }
                    onChange={(e, value) =>
                      onChangeHandler(value?.id, "manager", getDetails)
                    }
                    renderInput={(params) => <TextField {...params} />}
                  />
                  <FormHelperText>
                    {formik.errors.manager && formik.touched.manager
                      ? formik.errors.manager
                      : ""}
                  </FormHelperText>
                </FormControl>
              <div>
                <FormControl
                  fullWidth
                  error={
                    formik.errors.teamLead && formik.touched.teamLead ? true : false
                  }
                >
                  <InputLabel className="custom-label" shrink={false}>Team Lead</InputLabel>
                  <Autocomplete
                    disabled={componentType === "view" ? true : false}
                    options={teamLeadObj}
                    getOptionLabel={(option) => {
                      let fullName = option.firstName + " " + option.lastName;
                      return fullName ? fullName : "";
                    }}
                    value={
                      getDetails.teamLead
                        ? teamLeadObj.find((x) => x.id === getDetails.teamLead) ||
                          null
                        : null
                    }
                    onChange={(e, newValue) =>
                      onChangeHandler(newValue?.id, "teamLead", getDetails)
                    }
                    renderInput={(params) => <TextField {...params} />}
                  />
                  <FormHelperText>
                    {formik.errors.teamLead && formik.touched.teamLead
                      ? formik.errors.teamLead
                      : ""}
                  </FormHelperText>
                </FormControl>
              </div>
              <div>
                <FormControl fullWidth style={{ marginTop: "20px" }}>
                  <InputLabel shrink={false} className='custom-label'>Recruiter</InputLabel>
                  <Autocomplete
                    multiple
                    limitTags={2}
                    disabled={
                      componentType === "view" || !systemRole ? true : false
                    }
                    options={recruiterObj}
                    value={recruitersObj || []}
                    getOptionLabel={(option) => option.name}
                    onChange={(e, value) => {
                      let selectedValues = value.map((v) => v.id);
                      onChangeHandler(selectedValues, "recruiters", getDetails);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </FormControl>
              </div>
            </div>
          </div>
          {/* Client Section */}
          {userInfo?.[0]?.clientStatus === 1 ?
          <div style={{width: "32.5%"}}>
            <div className="jobpostings-container clients-container">
              <h3 className="heading" style={{marginBottom: "20px"}}>Client</h3>
                <div>
                  {/* CLIENT */}
                  {renderClientColumn()}

                  {/* END CLIENT */}
                  <div>
                    <div className="client-section" style={{marginTop: "20px"}}>
                      <InputLabel shrink={false} className="custom-label">End Client</InputLabel>
                      <Autocomplete
                        options={(endClientsData?.endClients || []).filter(
                          (c) => c.status === 1,
                        )}
                        autoHighlight
                        className="clientsearch1"
                        sx={{
                          width: 503,
                          "& .MuiAutocomplete-clearIndicator": { display: "none" },
                        }}
                        style={{
                          width: "100%",
                          borderRadius: "120px",
                        }}
                        disableClearable={false}
                        value={
                          endClientsData?.endClients?.find(
                            (x) => String(x.id) === String(getDetails.endClientId),
                          ) || null
                        }
                        disabled={componentType === "view" || !hasEndClient}
                        getOptionLabel={(option) => option?.name || ""}
                        onChange={(e, value) => {
                          onChangeHandler(
                            value?.id ? String(value.id) : null,
                            "endClientId",
                            getDetails,
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="boldlabel"
                            onBlur={formik.handleBlur}
                          />
                        )}
                      />
                      <BsSearch
                        style={{ paddingTop: "1.2rem", marginLeft: "-2rem" }}
                      />
                    </div>

                    <span style={{ float: "initial" }}>
                      <FormControlLabel
                        style={{
                          backgroundColor:
                            componentType === "view" ? "transparent" : "inherit",
                        }}
                        control={
                          <Checkbox
                            checked={
                              Boolean(getDetails.isEndClientConfidential) || false
                            }
                            disabled={componentType === "view" || !hasEndClient}
                            onChange={(e) =>
                              onChangeHandler(
                                e.target.checked,
                                "isEndClientConfidential",
                                getDetails,
                              )
                            }
                            name="isEndClientConfidential"
                            sx={{
                              color: "#fbc02d",
                              borderRadius: "4px",
                              "&.Mui-checked": {
                                color: "#fbc02d",
                              },
                              "&:not(.Mui-checked)": {
                                color: "#000000",
                              },
                            }}
                          />
                        }
                        label={
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            Keep End Client Confidential
                          </span>
                        }
                      />
                    </span>
                  </div>
                </div>
            </div>
          </div> :""}
        </div>
        
      {customFieldsArray && customFieldsArray.length > 0 && (
        <div className="jobpostings-container">
          <h3 className="heading">{userInfo && Object.keys(userInfo).length > 0 ? userInfo[0]?.companyName : ""}</h3>
          <div
            id="customFields"
            style={{
              display: "flex",
              flexFlow: "wrap",
              marginTop: "50px",
              gap: "0% 2%",
            }}
          >
            {/* customFields Ui render start here */}
            {
              customFieldsArray.map((data, index) => {
                const err = formik.errors?.customFields?.[data.fieldName];
                const touched = formik.touched?.customFields?.[data.fieldName];
                const hasError = Boolean(
                  err && (touched || formik.submitCount > 0),
                );
                const isReq = Number(data.mandatory) === 1;

                if (data.dataType.toLowerCase().trim() === "text box") {
                  return (
                    <div style={{ width: "23.5%", marginBottom: "45px" }}>
                      <FormControl fullWidth>
                        <InputLabel shrink={false} className="custom-label">{`${data.fieldName}${Number(data.mandatory) === 1 ? " *" : ""}`}</InputLabel>
                        <TextField
                          className="boldlabel"
                          id={`customFields.${data.fieldName}`}
                          variant="outlined"
                          autoComplete="off"
                          style={{ width: "100%" }}
                          error={hasError}
                          helperText={hasError ? err : ""}
                          name={`customFields.${data.fieldName}`}
                          disabled={componentType === "view" ? true : false}
                          // value={getcustomFields && Object.keys(getcustomFields).includes(data.fieldName) ? getcustomFields[data.fieldName] : ''}
                          value={getcustomFields?.[data.fieldName] ?? ""}
                          onChange={(e) =>
                            onChangeCustomFieldsHandler(
                              e.target.value,
                              data.fieldName,
                            )
                          }
                          // onBlur={() => formik.setFieldTouched(`customFields.${data.fieldName}`, true)}
                          onBlur={formik.handleBlur}
                        />
                      </FormControl>
                    </div>
                  );
                } else if (
                  data.dataType.toLowerCase().trim() === "multi select"
                ) {
                  return (
                    <div style={{ width: "23.5%", marginBottom: "45px" }}>
                      <FormControl
                        fullWidth
                        error={hasError}
                        required={isReq}
                        sx={{
                          width: "100%",
                          "& .MuiInputLabel-root": {
                            color: "#000",
                          },
                        }}
                      >
                        <InputLabel
                          shrink={false} className="custom-label"
                          id={`${data.fieldName}-label`}
                        >
                          {data.fieldName}
                        </InputLabel>
                        <Select
                          id={`customFields.${data.fieldName}`}
                          multiple
                          name={`customFields.${data.fieldName}`}
                          disabled={componentType === "view" ? true : false}
                          // value={getcustomFields && Object.keys(getcustomFields).includes(data.fieldName) ? getcustomFields[data.fieldName] : []}
                          value={
                            Array.isArray(getcustomFields?.[data.fieldName])
                              ? getcustomFields[data.fieldName]
                              : []
                          }
                          onChange={(e) =>
                            onChangeCustomFieldsHandler(
                              e.target.value,
                              data.fieldName,
                            )
                          }
                          onBlur={formik.handleBlur}
                          renderValue={(selected) => {
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                  maxHeight: "65px",
                                  overflowX: "auto",
                                }}
                              >
                                {typeof selected !== "string" &&
                                  selected.map((value) => (
                                    <Chip key={value} label={value} />
                                  ))}
                              </Box>
                            );
                          }}
                        >
                          {data?.customValues &&
                            data.customValues.length > 0 &&
                            data.customValues.map((name) => (
                              <MenuItem
                                className="selectOptions"
                                key={name}
                                value={name}
                              >
                                {name}
                              </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{hasError ? err : ""}</FormHelperText>
                      </FormControl>
                    </div>
                  );
                } else if (
                  data.dataType.toLowerCase().trim() === "single select"
                ) {
                  return (
                    <div style={{ width: "23.5%", marginBottom: "45px" }}>
                      <FormControl fullWidth error={hasError} required={isReq}
                        sx={{
                          "& .MuiInputLabel-root": {
                            color:  "#000",
                          },
                        }}
                      >
                        <InputLabel
                          shrink={false} className="custom-label"
                          id={`${data.fieldName}-label`}
                        >
                          {data.fieldName}
                        </InputLabel>
                        <Select
                          name={`customFields.${data.fieldName}`}
                          labelId={`${data.fieldName}-label`}
                          id={`customFields.${data.fieldName}`}
                          autoComplete="off"
                          // value={getcustomFields && Object.keys(getcustomFields).includes(data.fieldName) ? getcustomFields[data.fieldName] : []}
                          value={getcustomFields?.[data.fieldName] ?? ""}
                          variant="outlined"
                          style={{
                            width: "100%",
                            height: "3.5rem",
                            borderRadius: "4px",
                          }}
                          onChange={(e) =>
                            onChangeCustomFieldsHandler(
                              e.target.value,
                              data.fieldName,
                            )
                          }
                          onBlur={formik.handleBlur}
                          disabled={componentType === "view" ? true : false}
                        >
                          {data?.customValues &&
                            data.customValues.length > 0 &&
                            data.customValues.map((name) => {
                              return <MenuItem value={name}>{name}</MenuItem>;
                            })}
                        </Select>
                        <FormHelperText>{hasError ? err : ""}</FormHelperText>
                      </FormControl>
                    </div>
                  );
                }
              })}
          </div>
          {/* customFields Ui render end here */}
        </div>
  )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          marginTop: "0px",
        }}
      >
        <FormControl
          fullWidth
          error={formik.errors.jobDesc && formik.touched.jobDesc ? true : false}
        >
          <InputLabel
            style={{ marginLeft: "-13px!important" }}
            autoComplete="off"
            className="headerLabel"
          >
            Job Description*
          </InputLabel>
          <div
            id="jobDesc"
            className={
              formik.errors.jobDesc && formik.touched.jobDesc
                ? "brd-danger"
                : ""
            }
          >
            <CkEditor
              data={jobDescValue && jobDescValue === "" ? " " : jobDescValue}
              error={
                formik.errors.jobDesc && formik.touched.jobDesc ? true : false
              }
              name="jobDesc"
              autoComplete="off"
              isReadonly={componentType === "view" ? true : false}
              onUpdatehandler={(update) =>
                onChangeHandler(update.data, "jobDesc")
              } //onChangeHandler(update, "jobDesc", getDetails)}
              onBlur={formik.handleBlur}
            />
          </div>
          {formik.errors.jobDesc && formik.touched.jobDesc ? (
            <FormHelperText className="text-danger">
              Please enter a job description
            </FormHelperText>
          ) : (
            ""
          )}
        </FormControl>
      </div>
      <div
        id="eqlColHeight"
        style={{
          display: "flex",
          flexFlow: "wrap",
          marginTop: "30px",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div style={{ width: "32%" }}>
          <FormControl fullWidth>
            <InputLabel shrink={false} className="headerLabel">Primary Skills</InputLabel>
            <TextField
              className="boldlabel"
              autoComplete="off"
              error={
                formik.errors.primarySkills && formik.touched.primarySkills
                  ? true
                  : false
              }
              helperText={
                formik.errors.primarySkills && formik.touched.primarySkills
                  ? formik.errors.primarySkills
                  : ""
              }
              id="primarySkills"
              variant="outlined"
              multiline={true}
              rows={10}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 4,
                  marginTop: "-4px"
                },
              }}
              name="primarySkills"
              value={getDetails.primarySkills}
              onChange={(e) =>
                onChangeHandler(e.target.value, "primarySkills", getDetails)
              }
              onKeyDown={formik.handleBlur}
              onBlur={formik.handleBlur}
              disabled={componentType === "view" ? true : false}
            />
          </FormControl>
        </div>
        <div style={{ width: "32%" }}>
          <FormControl fullWidth>
            <InputLabel shrink={false} className="headerLabel">Secondary Skills</InputLabel>
            <TextField
              className="boldlabel"
              id="secondarySkills"
              autoComplete="off"
              variant="outlined"
              multiline={true}
              rows={10}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 4,
                  marginTop: "-4px"
                },
              }}
              name="secondarySkills"
              value={getDetails.secondarySkills}
              onChange={(e) =>
                onChangeHandler(e.target.value, "secondarySkills", getDetails)
              }
              onBlur={formik.handleBlur}
              disabled={componentType === "view" ? true : false}
            />
          </FormControl>
        </div>
        <div style={{ width: "32%", marginTop: "-5px" }}>
          <FormControl fullWidth error={isjobDescForSM === true ? true : false}>
            <InputLabel
              autoComplete="off"
              className={
                isjobDescForSM === true ? " headerLabel" : "headerLabel"
              }
            >
              Job Description For Social Media
            </InputLabel>
            <div
              id="jobDescForSMnew"
              onKeyDown={formik.handleBlur}
              // className={isjobDescForSM === true ? "brd-danger" : ""}
            >
              <CkEditor
                data={
                  jobDescforSMValue && jobDescforSMValue === ""
                    ? " "
                    : jobDescforSMValue
                }
                name="jobDescForSMnew"
                autoComplete="off"
                isReadonly={componentType === "view" ? true : false}
                onUpdatehandler={(update) => {
                  onChangeHandler(update.data, "jobDescForSM");
                }}
              />
            </div>
            {/* {isjobDescForSM === true ? (
              <FormHelperText className="text-danger" style={{ position: "absolute", bottom: "-28px", letterSpacing: "-0.3px" }}>
                Please enter description for social media
              </FormHelperText>

            ) : (
              ""
            )} */}
          </FormControl>
        </div>
      </div>
      {componentType === "Create" ? (
        <div
          className="jpacionbuttons"
          style={{
            marginLeft: "auto!important",
            width: "fit-content",
            marginTop: "60px",
            marginLeft: "auto",
            marginRight: "-13px",
          }}
        >
          {actions &&
            actions.map((item) => {
              if (item.type === "back") {
                return (
                  <Button
                    className={item.class}
                    variant={item.variant}
                    style={item.style}
                    size="small"
                    onClick={() => navigate(item.navigateTo)}
                  >
                    {item.label}{" "}
                  </Button>
                );
              } else if (item.type === "submit") {
                return (
                  <Button
                    className={item.class}
                    variant={item.variant}
                    style={item.style}
                    size="small"
                    disabled={disableBtn}
                    onClick={formik.handleSubmit}
                  >
                    {item.label}{" "}
                  </Button>
                );
              }
            })}
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

export default React.memo(PostingsComponent);
